export function getItemStatus(status: string,): string {
  if (status.toUpperCase() === 'ACTIVE' || status.toUpperCase() === 'PENDING') {
    return 'Submitted';
  } else if (status.toUpperCase() === 'SOLD') {
    return 'Sold';
  } else {
    return 'Unknown';
  }
}
